import React from 'react'
import { WrappedFieldProps } from 'redux-form'
import CodeEditor from '@uiw/react-textarea-code-editor'

import { Form } from 'antd'
import { TextAreaProps } from 'antd/lib/input'
import { FormItemLabelProps } from 'antd/lib/form/FormItemLabel'
import cx from 'classnames'

const { Item } = Form

type Props = WrappedFieldProps &
	TextAreaProps &
	FormItemLabelProps & {
		language?: string
		minHeight?: number
	}

const CodeEditorField = (props: Props) => {
	const {
		input,
		disabled,
		label,
		meta: { error, touched },
		style,
		readOnly,
		placeholder,
		language,
		className,
		minHeight
	} = props

	return (
		<Item
			label={label}
			style={style}
			help={touched && error}
			className={cx({ 'form-item-disabled': disabled, readOnly })}
			validateStatus={error && touched ? 'error' : undefined}
		>
			<CodeEditor
				language={language}
				placeholder={placeholder}
				padding={8}
				style={{
					fontSize: 12
				}}
				className={className}
				minHeight={minHeight}
				value={input.value || ''}
				onChange={input.onChange}
				disabled={disabled}
			/>
		</Item>
	)
}

export default CodeEditorField
